<template>
  <!-- <Nav /> -->
  <router-view :key="$route.fullPath"/>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background:#000 ;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
// @ is an alias to /src
import axios from "axios";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance
} from "vue";


// import Left1Line from "../components/cangchu/left1Line";
import Nav from "./components/nav.vue";
import { useRouter } from 'vue-router'


import { setInterval, clearInterval } from "timers";
export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
    });
    onMounted(() => {

       
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
      
    })



    return {

    };
  },
  components: {
    Nav
  },
};
</script>



